import { render, staticRenderFns } from "./analysisReportAdmin.vue?vue&type=template&id=2b1a5e49&scoped=true"
import script from "./analysisReportAdmin.vue?vue&type=script&lang=js"
export * from "./analysisReportAdmin.vue?vue&type=script&lang=js"
import style0 from "./analysisReportAdmin.vue?vue&type=style&index=0&id=2b1a5e49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1a5e49",
  null
  
)

export default component.exports